import { AUTHENTICATING_HUBSPOT_REQUEST, AUTHENTICATING_HUBSPOT_SUCCEDDED, AUTHENTICATING_HUBSPOT_FAILED,
    UPDATING_HUBSPOT_REQUEST, UPDATING_HUBSPOT_SUCCEDDED, UPDATING_HUBSPOT_FAILED, DELETING_SECONDARY_CONFIGURATION, DELETING_SECONDARY_CONFIGURATION_SUCCEEDED, DELETING_SECONDARY_CONFIGURATION_FAILED, FETCHING_TOTAL_HUBSPOT_INTEGRATIONS, FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_SUCCEEDED, FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_FAILED,
} from '../actionTypes.jsx';
import axios from 'axios';
import {activatingIntegrationSuccedded, deactivatingIntegrationSuccedded,
  integrationAuthExpired} from '../integrations';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const HUBSPOT_BASE_URL = `${apiUrl}/api/2.0/integrations/hubspot`;
const HUBSPOT_AUTHENTICATION_URL = `${HUBSPOT_BASE_URL}/authenticate`;
const HUBSPOT_UPDATE_URL = `${HUBSPOT_BASE_URL}`;

export function authenticateAccount(code){
  return function (dispatch) {
    dispatch(authenticatingAccount());

    const data = {
      code: code
    }

    return axios({
      method: 'POST',
      url: HUBSPOT_AUTHENTICATION_URL,
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      params: data
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error.response.data))
    )
  }
}

function authenticatingAccount(){
  return {
    type: AUTHENTICATING_HUBSPOT_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json){
  return {
    type: AUTHENTICATING_HUBSPOT_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error){
  return {
    type: AUTHENTICATING_HUBSPOT_FAILED,
    payload: error
  }
}

/**
* Update hubspot configuration
*/
export function updateConfiguration(configuration){
  return function (dispatch) {
    dispatch(updatingConfiguration());

    return axios({
      method: 'PUT',
      url: HUBSPOT_UPDATE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(integrationAuthExpired(error.errors, "hubspot"));
      dispatch(updatingConfigurationFailed(error))
    })
  }
}

function updatingConfiguration(){
  return {
    type: UPDATING_HUBSPOT_REQUEST,
    payload: {}
  }
}

function updatingConfigurationSuccedded(json){
  return {
    type: UPDATING_HUBSPOT_SUCCEDDED,
    payload: json
  }
}

function updatingConfigurationFailed(error){
  return {
    type: UPDATING_HUBSPOT_FAILED,
    payload: error
  }
}

// overridePrimaryConfiguration events

export function overridePrimaryConfiguration(configuration, id){
  return function (dispatch) {
    dispatch(overridingPrimaryConfiguration());

    return axios({
      method: 'PUT',
      url: `${HUBSPOT_UPDATE_URL}/${id}/override`,
      data: configuration
    })
    .then((response) => {
      dispatch(overridingPrimaryConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(integrationAuthExpired(error.errors, "hubspot"));
      dispatch(overridingPrimaryConfigurationFailed(error))
    })
  }
}

function overridingPrimaryConfiguration(){
  return {
    type: UPDATING_HUBSPOT_REQUEST,
    payload: {}
  }
}

function overridingPrimaryConfigurationSuccedded(json){
  return {
    type: UPDATING_HUBSPOT_SUCCEDDED,
    payload: json
  }
}

function overridingPrimaryConfigurationFailed(error){
  return {
    type: UPDATING_HUBSPOT_FAILED,
    payload: error
  }
}

//override primary account 

  export function overridePrimaryInstance(id, code){
    return function (dispatch) {
      dispatch(overridingPrimaryInstance());

      const data = {
        code: code
      }

      return axios({
        method: 'POST',
        url: `${HUBSPOT_UPDATE_URL}/${id}/change_user`,
        headers: {'Content-Type':'application/x-www-form-urlencoded'},
        params: data
      })
      .then((response) => {
        dispatch(overridingPrimaryInstanceSucceded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
      })
      .catch(error => {
        dispatch(integrationAuthExpired(error.errors, "hubspot"));
        dispatch(overridingPrimaryInstanceFailed(error))
      })
    }
  }

  function overridingPrimaryInstance(){
    return {
      type: UPDATING_HUBSPOT_REQUEST,
      payload: {}
    }
  }

  function overridingPrimaryInstanceSucceded(json){
    return {
      type: UPDATING_HUBSPOT_SUCCEDDED,
      payload: json
    }
  }

  function overridingPrimaryInstanceFailed(error){
    return {
      type: UPDATING_HUBSPOT_FAILED,
      payload: error
    }
  }

//override secondary account
export function overrideAccount(id, code){
  return function (dispatch) {
    dispatch(overridingAccount());

    const data = {
      code: code
    }

    return axios({
      method: 'POST',
      url: `${HUBSPOT_UPDATE_URL}/${id}/override/change_user`,
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      params: data
    })
    .then((response) => {
      dispatch(overridingAccountSucceded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(integrationAuthExpired(error.errors, "hubspot"));
      dispatch(overridingAccountFailed(error))
    })
  }
}

function overridingAccount(){
  return {
    type: UPDATING_HUBSPOT_REQUEST,
    payload: {}
  }
}

function overridingAccountSucceded(json){
  return {
    type: UPDATING_HUBSPOT_SUCCEDDED,
    payload: json
  }
}

function overridingAccountFailed(error){
  return {
    type: UPDATING_HUBSPOT_FAILED,
    payload: error
  }
}

//delete secondary configuration
export function deleteSecondaryConfiguration(id){
  return function (dispatch) {
    dispatch(deletingSecondaryConfiguration());

    return axios({
      method: 'DELETE',
      url: `${HUBSPOT_UPDATE_URL}/${id}`,
    })
    .then((response) => {
      dispatch(deletingSecondaryConfigurationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(deletingSecondaryConfigurationFailed(error))
    })
  }
}

function deletingSecondaryConfiguration(){
  return {
    type: DELETING_SECONDARY_CONFIGURATION,
    payload: {}
  }
}

function deletingSecondaryConfigurationSuccedded(json){
  return {
    type: DELETING_SECONDARY_CONFIGURATION_SUCCEEDED,
    payload: json
  }
}

function deletingSecondaryConfigurationFailed(error){
  return {
    type: DELETING_SECONDARY_CONFIGURATION_FAILED,
    payload: error
  }
}

export function fetchTotalHubspotIntegrations() {
  
  return function (dispatch) {
    dispatch(fetchingTotalHubspotIntegrations());
    return axios({
      method: 'GET',
      url: `${HUBSPOT_BASE_URL}/total_count`
    })

      .then((response) => {
        dispatch(fetchingTotalHubspotIntegrationsSucceeded(response.data));
      })
      .catch(error => {
        dispatch(fetchingTotalHubspotIntegrationsFailed(error.errors))
    }
    )
  }
}

function fetchingTotalHubspotIntegrations(){
  return {
    type: FETCHING_TOTAL_HUBSPOT_INTEGRATIONS,
    payload: {}
  }
}

function fetchingTotalHubspotIntegrationsSucceeded(response) {
  return {
    type: FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_SUCCEEDED,
    payload: response
  }
}

function fetchingTotalHubspotIntegrationsFailed(error){
  return {
    type: FETCHING_TOTAL_HUBSPOT_INTEGRATIONS_FAILED,
    payload: error
  }
}